import { MasterDataCompanySpecificIndustry } from "@/features/master-data/components/CompanySpecificIndustry/MasterDataCompanySpecificIndustry";
import { MasterDataLanguageTest } from "@/features/master-data/components/LanguageTest/MasterDataLanguageTest";
import { MasterDataNationality } from "@/features/master-data/components/Nationality/MasterDataNationality";
import { MasterDataResidencePeriod } from "@/features/master-data/components/ResidencePeriod/MasterDataResidencePeriod";
import { MasterDataSkillTest } from "@/features/master-data/components/SkillTest/MasterDataSkillTest";
import { MasterDataSupportLanguage } from "@/features/master-data/components/SupportLanguage/MasterDataSupportLanguage";
import { MasterDataSpecificSkillCertificate } from "@/features/master-data/components/SpecificSkillCertificate/MasterDataSpecificSkillCertificate";
import { MASTER_DATA_TYPE } from "@/features/master-data/constants/masterDataType";
import FeatureNotReadyPage from "@/pages/FeatureNotReadyPage";
import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";

export const MasterDataDetailPage: FC = () => {
  const { type: masterDataType } = useParams();

  const MasterDataDetailComponent = useMemo(() => {
    switch (masterDataType) {
      case MASTER_DATA_TYPE.NATIONALITY:
        return <MasterDataNationality />;
      case MASTER_DATA_TYPE.LANGUAGE_TEST:
        return <MasterDataLanguageTest />;
      case MASTER_DATA_TYPE.SKILL_TEST:
        return <MasterDataSkillTest />;
      case MASTER_DATA_TYPE.SUPPORT_LANGUAGE:
        return <MasterDataSupportLanguage />;
      case MASTER_DATA_TYPE.COMPANY_SPECIFIC_INDUSTRY:
        return <MasterDataCompanySpecificIndustry />;
      case MASTER_DATA_TYPE.SPECIFIC_SKILL_CERTIFICATE:
        return <MasterDataSpecificSkillCertificate />;
      case MASTER_DATA_TYPE.RESIDENCE_PERIOD:
        return <MasterDataResidencePeriod />;
      default:
        return <FeatureNotReadyPage />;
    }
  }, [masterDataType]);

  return <>{MasterDataDetailComponent}</>;
};
